// @ts-nocheck
import { enhanceDocumentSelects } from './selectEnhancer'
import { announcementBellIconMarkup } from './announcementIcon'
import { renderAnnouncementMarkdown } from './announcementMarkdown'
import { initThemeControls } from './theme'
import './autoHideScrollbar'

enhanceDocumentSelects();
initThemeControls();

(() => {
  const body = document.body;
  const storageKey = body.classList.contains("admin-body") ? "arena-admin-sidebar-collapsed" : "arena-sidebar-collapsed";
  const collapseButtons = [...document.querySelectorAll("[data-sidebar-toggle]")];
  const mobileButtons = [...document.querySelectorAll("[data-mobile-sidebar-toggle]")];
  const backdrop = document.querySelector("[data-sidebar-backdrop]");

  function setCollapsed(collapsed) {
    body.classList.toggle("sidebar-collapsed", collapsed);
    collapseButtons.forEach((button) => {
      button.setAttribute("aria-expanded", String(!collapsed));
      button.setAttribute("aria-label", collapsed ? "展开侧栏" : "收起侧栏");
      button.title = collapsed ? "展开侧栏" : "收起侧栏";
    });
    localStorage.setItem(storageKey, collapsed ? "true" : "false");
  }

  function closeMobile() {
    body.classList.remove("sidebar-mobile-open");
    mobileButtons.forEach((button) => button.setAttribute("aria-expanded", "false"));
  }

  function toggleMobile() {
    const open = !body.classList.contains("sidebar-mobile-open");
    body.classList.toggle("sidebar-mobile-open", open);
    mobileButtons.forEach((button) => button.setAttribute("aria-expanded", String(open)));
  }

  function setPage(title, description = "") {
    const titleNode = document.querySelector("#shellPageTitle");
    const descriptionNode = document.querySelector("#shellPageDescription");
    if (titleNode) titleNode.textContent = title;
    if (descriptionNode) {
      descriptionNode.textContent = description;
      descriptionNode.hidden = !description;
    }
  }

  function escapeHTML(value) {
    return String(value ?? "").replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character]);
  }

  function renderRollingAnnouncement(container, config, { forceVisible = false } = {}) {
    if (!container) return;
    const blocks = Array.isArray(config?.blocks) ? config.blocks.filter((block) => String(block?.content || "").trim()) : [];
    container.hidden = !(forceVisible || config?.enabled === true) || blocks.length === 0;
    if (!blocks.length) {
      container.innerHTML = "";
      return;
    }
    const group = (copy) => `<div class="rolling-announcement-group"${copy === 2 ? ' aria-hidden="true"' : ""}>${blocks.map((block, index) => `${index ? '<span class="rolling-announcement-separator" aria-hidden="true"></span>' : ""}<span class="rolling-announcement-block" data-announcement-color="${escapeHTML(block.color || "#2563EB")}">${renderAnnouncementMarkdown(block.content, copy === 1)}</span>`).join("")}</div>`;
    container.innerHTML = `<div class="rolling-announcement-signal" aria-hidden="true">${announcementBellIconMarkup}</div><div class="rolling-announcement-viewport"><div class="rolling-announcement-track">${group(1)}${group(2)}</div></div>`;
    container.querySelectorAll("[data-announcement-color]").forEach((element) => {
      element.style.color = /^#[0-9a-f]{6}$/i.test(element.dataset.announcementColor || "") ? element.dataset.announcementColor : "#2563EB";
    });
  }

  setCollapsed(localStorage.getItem(storageKey) === "true");
  collapseButtons.forEach((button) => button.addEventListener("click", () => setCollapsed(!body.classList.contains("sidebar-collapsed"))));
  mobileButtons.forEach((button) => button.addEventListener("click", toggleMobile));
  backdrop?.addEventListener("click", closeMobile);
  document.addEventListener("keydown", (event) => { if (event.key === "Escape") closeMobile(); });
  window.addEventListener("resize", () => { if (window.innerWidth >= 980) closeMobile(); });

  window.ArenaShell = { closeMobile, setPage };
  window.ArenaRollingAnnouncement = { render: renderRollingAnnouncement, renderMarkdown: renderAnnouncementMarkdown };
})();

export {}
